import React from 'react';
import { Link } from 'react-router-dom';

import type { TaskImportRunSchema } from '../../services/api/generated/taskImportRunsService';
import { RunStatusBadge } from './RunStatusBadge';

type Props = {
  runs: TaskImportRunSchema[];
  isLoading?: boolean;
};

export const RunListTable: React.FC<Props> = ({ runs, isLoading }) => {
  if (isLoading) {
    return <div className="text-sm text-gray-600">Loading runs…</div>;
  }

  if (!runs || runs.length === 0) {
    return <div className="text-sm text-gray-600">No runs yet.</div>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-left text-sm">
        <thead className="text-xs uppercase text-gray-500">
          <tr>
            <th className="px-2 py-2">Firm</th>
            <th className="px-2 py-2">Date</th>
            <th className="px-2 py-2">CMS</th>
            <th className="px-2 py-2">Phase</th>
            <th className="px-2 py-2">Report</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {runs.map((run) => (
            <tr key={String(run.id)} className="hover:bg-gray-50">
              <td className="px-2 py-2">
                <Link
                  to={`/profile/external-cms/runs/${run.id}`}
                  className="text-blue-700 hover:underline"
                >
                  {run.firm?.name ?? String(run.firm_id)}
                </Link>
              </td>
              <td className="px-2 py-2">
                {(() => {
                  const createdAt = (run as unknown as { created_at?: string })
                    .created_at;
                  return createdAt ? new Date(createdAt).toLocaleString() : '';
                })()}
              </td>
              <td className="px-2 py-2">{run.cms_type}</td>
              <td className="px-2 py-2">
                <RunStatusBadge phase={run.phase} />
              </td>
              <td className="px-2 py-2">
                {run.file_name ? (
                  <a
                    href={run.file_url ?? '#'}
                    className="text-blue-700 hover:underline"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Download report
                  </a>
                ) : (
                  <span className="text-gray-500">—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
